import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import mcpKeysAPI from '../../api/mcpKeys';

const state = {
  records: [],
  availableTools: [],
  uiFlags: {
    fetchingList: false,
    fetchingAvailableTools: false,
    creatingItem: false,
    updatingItem: false,
    deletingItem: false,
  },
};

export const getters = {
  getMcpKeys(_state) {
    return [..._state.records].sort((k1, k2) => k2.id - k1.id);
  },
  getAvailableTools(_state) {
    return _state.availableTools;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async get({ commit }) {
    commit(types.default.SET_MCP_KEY_UI_FLAG, { fetchingList: true });
    try {
      const response = await mcpKeysAPI.get();
      commit(types.default.SET_MCP_KEYS, response.data.payload);
    } finally {
      commit(types.default.SET_MCP_KEY_UI_FLAG, { fetchingList: false });
    }
  },

  async getAvailableTools({ commit }) {
    commit(types.default.SET_MCP_KEY_UI_FLAG, { fetchingAvailableTools: true });
    try {
      const response = await mcpKeysAPI.getAvailableTools();
      commit(types.default.SET_MCP_AVAILABLE_TOOLS, response.data);
    } finally {
      commit(types.default.SET_MCP_KEY_UI_FLAG, { fetchingAvailableTools: false });
    }
  },

  async create({ commit }, params) {
    commit(types.default.SET_MCP_KEY_UI_FLAG, { creatingItem: true });
    try {
      const response = await mcpKeysAPI.create(params);
      const { secret, client_secret: clientSecret, ...mcpKey } = response.data;
      commit(types.default.ADD_MCP_KEY, mcpKey);
      return response.data;
    } finally {
      commit(types.default.SET_MCP_KEY_UI_FLAG, { creatingItem: false });
    }
  },

  async update({ commit }, { id, ...updateObj }) {
    commit(types.default.SET_MCP_KEY_UI_FLAG, { updatingItem: true });
    try {
      const response = await mcpKeysAPI.update(id, updateObj);
      commit(types.default.UPDATE_MCP_KEY, response.data);
    } finally {
      commit(types.default.SET_MCP_KEY_UI_FLAG, { updatingItem: false });
    }
  },

  async delete({ commit }, id) {
    commit(types.default.SET_MCP_KEY_UI_FLAG, { deletingItem: true });
    try {
      await mcpKeysAPI.delete(id);
      commit(types.default.UPDATE_MCP_KEY, { id, status: 'revoked' });
    } finally {
      commit(types.default.SET_MCP_KEY_UI_FLAG, { deletingItem: false });
    }
  },
};

export const mutations = {
  [types.default.SET_MCP_KEY_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_MCP_KEYS]: MutationHelpers.set,
  [types.default.SET_MCP_AVAILABLE_TOOLS](_state, data) {
    _state.availableTools = data;
  },
  [types.default.ADD_MCP_KEY]: MutationHelpers.create,
  [types.default.UPDATE_MCP_KEY]: MutationHelpers.updateAttributes,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
